import "./scss/main.scss";
import {
  ChannelFetch,
  Channel,
  ViewStream,
  ChannelPayload,
  SpyneApp,
  SpyneAppProperties,
  SpynePlugin,npm
} from "spyne";


import { SpynePluginConsole } from "spyne-plugin-console";


import { SpynePluginPostMsg } from "@franciscobatista/spyne-plugin-post-msg-tmp";
//import {SpynePluginCms} from "@franciscobatista/spyne-plugin-cms";




import { SpyneCmsPlugin } from "@spynejs/cms";

import { SpynePluginCodePlayground } from "@franciscobatista/spyne-plugin-code-playground";

//import {SpynePluginJsonCms} from "@franciscobatista/spyne-plugin-json-cms";

//console.log("CMS IS ",SpynePluginJsonCms);
import { createAuth0Client } from "@auth0/auth0-spa-js";
//import * as auth0 from "@auth0/auth0-spa-js";

//import { ChannelCodeGen } from "@franciscobatista/spyne-plugin-code-playground";
//import {SpynePluginStarterTemplate} from 'spyne-plugin-starter-template';
//import {SpynePluginWysiwygEditor} from 'spyne-plugin-wysiwyg-editor';
//import {SpynePluginWysiwygEditor} from "spyne-plugin-wysiwyg-editor";
import { ChannelMenuDrawer } from "channels/channel-menu-drawer";
import { ChannelAppRoute } from "channels/channel-app-route";
import AppContentData from "data/app-data.json";
//import SpyneDocsJson5Data from 'data/spyne-docs-data.json5';
import { AppDataTraits } from "traits/app-data-traits";
import { AppView } from "./app/app-view";
//const json5 = require('json5');
import { ChannelCodeContainer } from "channels/channel-code-container.js";
import CodeGenData from "data/code-gen-data.json";
import SpyneDocsData from "data/spyne-docs-data.json";
import AuthConfigData from "data/auth-config.json";
import TOSData from "data/tos.json";

import BlogData from "data/blog-data.json";


//import {ChannelCopyClipboard} from 'channels/channel-copy-clipboard.js';
import { ChannelSidebar } from "channels/channel-sidebar";
import { UtilTraits } from "traits/util-traits";

import { ChannelSpyneDocsData } from "channels/channel-spyne-docs-data";

import { ChannelModalWindow } from "channels/channel-modal-window.js";

import { ChannelExternalEventsLauncher } from "channels/channel-external-events-launcher.js";
import { ChannelAuth } from "channels/channel-auth.js";

//const R = require("ramda");

//console.log("IFRAME PATH ",IFRAMES_PATH)
//window.R = R;

//console.log('wys ',SpynePluginWysiwygEditor);

const loadAscii = () => {
  console.log(
      '%c ____                             _ ____  \n' +
      '/ ___| _ __  _   _ _ __   ___    | / ___| \n' +
      '\\___ \\| \'_ \\| | | | \'_ \\ / _ \\_  | \\___ \\ \n' +
      ' ___) | |_) | |_| | | | |  __/ |_| |___) |\n' +
      '|____/| .__/ \\__, |_| |_|\\___|\\___/|____/ \n' +
      '      |_|    |___/                        \n\n' +
      '%cThis site is built with SpyneJS \u2014 the behavior-first frontend framework.\n' +
      '%cLooking for globals? There are none \u2014 the application runs entirely in memory.\n' +
      'Development builds reveal only the version.\n\n' +
      '%cStart your own:   %cnpx spyne-cli create-app\n\n' +
      '%cThe knowledge base, for you and your agents:   %cnpmjs.com/package/@spynejs/kb\n\n' +
      '%cQuestions: frank@spynejs.com',
      'color: #ffffff; font-family: monospace; font-size: 12px; line-height: 1.2;',
      'color: #5DCAA5; font-size: 15px; font-weight: 600; font-family: -apple-system, sans-serif;',
      'color: #9fb3ac; font-size: 13px; font-family: -apple-system, sans-serif; line-height: 1.5;',
      'color: #5DCAA5; font-size: 14px; font-weight: 600; font-family: -apple-system, sans-serif;',
      'color: #e8f3ee; font-family: monospace; font-size: 13px; background: #2f3a36; padding: 2px 6px; border-radius: 4px;',
      'color: #5DCAA5; font-size: 14px; font-weight: 600; font-family: -apple-system, sans-serif;',
      'color: #e8f3ee; font-family: monospace; font-size: 13px; background: #2f3a36; padding: 2px 6px; border-radius: 4px;',
      'color: #8a9a94; font-size: 12px; font-family: -apple-system, sans-serif;'
  );
};
window.setTimeout(loadAscii, 2000);


const debugMode = process.env.NODE_ENV === "development";

const hamburgerBreakpoint = 768;

const routePathTypeId = {
  routePath: {
    routeName: "exampleId",
    ".*": ".*",
  },
};
//          "404": ".+",
const config = {
  appGenMode: false,
  mode: "app",
  iframes: {
    allow: true,
    allowedOrigins: ["https://stackblitz.com"],
    // Don't force the default sandbox (allow-scripts + allow-same-origin)
    // onto iframes: ours are local/same-origin, where that flag pair is
    // self-escapable anyway — Chrome warned about it on every playground
    // frame (24x on reference pages). Iframes that declare their own
    // sandbox attribute keep it.
    sandbox: false
  },
  anchors: {
    allowTarget: true,
    addNoopener: true
  },
  debug: true,
  strict: false,
  pluginMethods: {
    enableScrollLock: (e) => console.log("SCROLL LOCK ENABLED ", e),
    disableScrollLock: (e) => console.log("SCROLL LOCK DISABLED ", e),
  },
  channels: {
    ROUTE: {
      type: "slash",
      isHash: false,
      isHidden: false,
      add404s: false,
      routes: {
        routePath: {
          routeName: "pageId",
          h1ome: "^$|index.html",
          home: ["","index.html"],
          "kb": "kb",
          /* "getting-startd": {
            "routePath": {
              "404": ".+",
              "routeName": "typeId",
              "init-application": "init-application",
              "viewstream" : routePathTypeId,
              "channels": routePathTypeId,
              "traits": "traits"
            }
          },*/
          quickstart: "quickstart",
          docs: {
            routePath: {
              routeName: "stage",
              stage: "stage",
              routePath: {
                routeName: "container",
                section: "container",
                routePath: {
                  routeName: "section",
                  topic: "section",
                  routePath: {
                    routeName: "topic",
                    ".*": ".*",
                  },
                },
              },
            },
          },

          reference: {
            routePath: {
              routeName: "stage",
              stage: "stage",
              routePath: {
                routeName: "classMethod",
                classMethod: "classMethod",
              },
            },
          },

          configure: {
            routePath: {
              routeName: "section",
              section: "section",
            },
          },
          tools: {
            routePath: {
              routeName: "section",
              section: "section",
            },
          },

          blog: {
            routePath: {
              routeName: "section",
              section: "section",
              "frontend-has-reached-its-reasoning-moment" : "frontend-has-reached-its-reasoning-moment"
            },
          },

          "architecture-as-data" : {
            routePath: {
              routeName: "section",
              section: "section",
            },
          },
          "early-access": {
            routePath: {
              routeName: "success",
              section: "success",
              topic: "success",
              routePath: {
                routeName: "topic",
                ".*": ".*",
              },
            },
          },
          investors: {
            routePath: {
              routeName: "section",
              section: "section",
              topic: "section",
              routePath: {
                routeName: "topic",
                ".*": ".*",
              },
            },
          },
          pricing: {
            routePath: {
              routeName: "section",
              section: "section",
              topic: "section",
              routePath: {
                routeName: "topic",
                ".*": ".*",
              },
            },
          },
          plans: {
            routePath: {
              routeName: "section",
              section: "section",
              topic: "section",
              routePath: {
                routeName: "topic",
                ".*": ".*",
              },
            },
          },

          deck: {
            routePath: {
              routeName: "section",
              section: "section",
              topic: "section",
              routePath: {
                routeName: "topic",
                ".*": ".*",
              },
            },
          },

          github: "github",
        },
      },
    },
    WINDOW: {
      mediaQueries: {
        showMenuDrawer: `(max-width: ${hamburgerBreakpoint}px)`,
      },
      events: ['click','mouseover','mouseenter','keydown','message','keyup'],
      listenForScroll: false,
      listenForOrientation: true,
      debounceMSTimeForScroll: 50,
    },
  },
};

SpyneApp.init(config);

let dataMapper = (o) => o;

// const {SpynePluginJsonCms} =  require('@frannpmn pciscobatista/spyne-plugin-json-cms');

const cmsPluginConfig = {
  position: ["bottom", "right"],
  openOnLoad: true,
  darkMode: true,
  maximize: true,
};

// updating code to clear cache trying to clear cache now
SpyneAppProperties.setProp('myTestKey', Math.random());

if (process.env.NODE_ENV === "development") {

  const delayAddCMS = ()=>{

    const spyneCmsPlugin = new SpyneCmsPlugin(cmsPluginConfig);

    SpyneApp.registerPlugin(spyneCmsPlugin);
    dataMapper = SpyneApp.pluginsFn.mapCmsData;

  }

  window.setTimeout(delayAddCMS, 100);

}



SpyneAppProperties.setProp("IFRAMES_PATH", IFRAMES_PATH);
SpyneAppProperties.setProp("NODE_ENV", process.env.NODE_ENV);
//SpyneAppProperties.setProp("apiDynamoDb", "https://hkt83pz461.execute-api.us-east-1.amazonaws.com/default/spynejs-auth-dynamodb-api")

SpyneAppProperties.setProp("apiDynamoDb", "https://rignctyz25.execute-api.us-east-1.amazonaws.com/user");
//SpyneAppProperties.setProp("previewSite", "http://localhost:8070");
SpyneAppProperties.setProp("previewSite", "https://preview.spynejs.com");



//SpyneAppProperties.setProp("apiDynamoDb", "http://127.0.0.1:3020/user");
SpyneApp.registerChannel(new ChannelAuth());

const startSite = () => {
/*  const myChannel = new ChannelFetch("CHANNEL_MY_CHANNEL", {
    url: "//jsonplaceholder.typicode.com/posts",
  });
  SpyneApp.registerChannel(myChannel);*/

  //console.log("UTIL CHANNEL ",new ChannelPayload("CHANNEL_NAME", "CHANNEL_ACTION", {}));
  //console.log("UTIL CHANNEL ",new SpynePlugin());

  //SpyneApp.registerChannel(new ChannelCodeGen());
  SpyneApp.registerPlugin(new SpynePluginCodePlayground());


  SpyneApp.registerChannel(new ChannelAppRoute());
  SpyneApp.registerChannel(new ChannelMenuDrawer());
  SpyneApp.registerChannel(new ChannelSidebar());
  SpyneApp.registerChannel(new ChannelCodeContainer());
  SpyneApp.registerChannel(new ChannelExternalEventsLauncher());
  SpyneApp.registerChannel(

      new ChannelFetch("CHANNEL_FETCH_TOS", {
        url:TOSData
      })


  )

  SpyneApp.registerChannel(new ChannelModalWindow());

  SpyneApp.registerChannel(
    new ChannelFetch("CHANNEL_APP_API", {
      url: AppContentData,
      map3: SpyneApp.pluginsFn.mapCmsData,
      map1: (d, metaData) => {
        const data = AppDataTraits.api$MapData(d);
        return SpyneApp.pluginsFn.mapCmsData(d, metaData);
      },
    }),
  );

  SpyneApp.registerChannel(new ChannelSpyneDocsData());

//  SpyneApp.registerChannel(new ChannelCodeGen());


  const spynePluginPostMsg = new SpynePluginPostMsg({
    name: "preview",
    allowedOrigins: [
        "auth.spynejs.com",
      "https://dev-spyne.us.auth0.com",
      "*localhost:8060",
      "*localhost:8070",
      "*.spynejs.com",
      "*.spynejs.org",
    ],
  });
  SpyneApp.registerPlugin(spynePluginPostMsg);

  SpyneApp.registerChannel(
    new ChannelFetch("CHANNEL_SPYNE_DOCS_JSON", {
      url: SpyneDocsData,
      disableSanitize: true,
      map: dataMapper,
    }),
  );
  SpyneApp.registerChannel(
    new ChannelFetch("CHANNEL_CODE_GEN_JSON", {
      url: CodeGenData,
      disableSanitize: true,
      map: dataMapper,
    }),
  );

  SpyneApp.registerChannel(
      new ChannelFetch("CHANNEL_BLOG_DATA_JSON", {
        url: BlogData,
        map: dataMapper,
      }),
  );



  SpyneApp.registerChannel(
    new ChannelFetch("CHANNEL_AUTH_CONFIG", {
      url: AuthConfigData,
    }),
  );


  if (process.env.NODE_ENV === "development") {
    const consolePlugin = new SpynePluginConsole({
      position: ["bottom", "right"],
      minimize: false,
    });

    SpyneApp.registerPlugin(consolePlugin);
  }


  //const {SpynePluginConsole} = require('spyne-plugin-console');

  //console.log("JSON CRUD IS ",JSON_CRUD_FILE);

  const addCodePlayground = (data, theMetaData) => {
    const metaData = {
      channelName: "CHANNEL_CODE_GEN_JSON",
      url: CodeGenData,
      responseType: "json",
      serverOptions: {
        method: "GET",
        headers: {
          Accept: "application/json, text/plain, */*",
        },
      },
    };
    //console.log("CODE DATA3 IS ",{metaData,theMetaData, data})

    const codeData = dataMapper(data, metaData);

    // new SpynePluginCodePlayground({codeDataFile:CodeGenData, codeData}, SpyneAppProperties);
  };
  /*    new ChannelFetchUtil({
      url:CodeGenData,
    }, addCodePlayground)*/

  if (process.env.NODE_ENV !== "development2") {
    // new SpynePluginCodePlayground({codeDataFile:CodeGenData}, SpyneAppProperties);
  }

  const loadAuth0 = () => {
    new ViewStream({ id: "profile", tagName: "article" }).prependToDom(
      document.body,
    );

    /*   auth0
      .createAuth0Client({
        domain: "dev-spyne.us.auth0.com",
        clientId: "1urOSko7njHjRqmBVozTAhYmXsZYNlPr",
        authorizationParams: {
          redirect_uri: `${window.location.origin}/callback`,
        },
      })
      .then(async (auth0Client) => {
        // Assumes a button with id "login" in the DOM
        const loginButton = document.getElementById("login");

        loginButton.addEventListener("click", (e) => {
          e.preventDefault();
          auth0Client.loginWithRedirect();
        });

        if (
          location.search.includes("state=") &&
          (location.search.includes("code=") ||
            location.search.includes("error="))
        ) {
          await auth0Client.handleRedirectCallback();
          window.history.replaceState({}, document.title, "/");
        }

        // Assumes a button with id "logout" in the DOM
        const logoutButton = document.getElementById("logout");

        logoutButton.addEventListener("click", (e) => {
          e.preventDefault();
          auth0Client.logout();
        });

        const isAuthenticated = await auth0Client.isAuthenticated();
        const userProfile = await auth0Client.getUser();

        // Assumes an element with id "profile" in the DOM
        const profileElement = document.getElementById("profile");

        if (isAuthenticated) {
          profileElement.style.display = "block";
          profileElement.innerHTML = `
            <p>${userProfile.name}</p>
            <img src="${userProfile.picture}" />
          `;
        } else {
          profileElement.style.display = "none";
        }
      });*/
  };

  // window.setTimeout(loadAuth0, 1000);

  // Initialize

  // Use auth0Client in your SPA

  //new SpynePluginScrollLock();
  /*  new ViewStream({
    tagName: 'h1',
    style: 'color:#ccc;padding:1rem;',
    data: "HELLO WORLD"
  }).appendToDom(document.body);*/

  new AppView().prependToDom(document.body);
};
window.setTimeout(startSite, 200);
